import {ContentPopperProps} from '@aboutyou/ui-components';
import React from 'react';
import type {CheckoutExperiment} from '../../hooks/useCheckoutEntryDetails';
import {useScaylePaymentMethodState} from '../../scayle-state/useScaylePaymentMethodState';
import {ExperimentActivationTriggerSlot} from '../../tracking/ExperimentActivationTriggerSlot';
import {BelowFieldsSlot} from './BelowFieldsSlot';
import {DisabledInvoicePaymentSlot} from './DisabledInvoicePaymentSlot';
import {RecommendedBadgeSlot} from './RecommendedBadgeSlot';
import {SelectedInvoicePaymentSlot} from './SelectedInvoicePaymentSlot';

export interface BnplSlotsProps {
  BnplInfoLayoutComponent: ContentPopperProps['LayoutComponent'];
  experiments: CheckoutExperiment[];
  authToken: string;
  appClientVersion?: string;
}

export const BnplSlots: React.FC<BnplSlotsProps> = ({
  BnplInfoLayoutComponent,
  experiments,
  authToken,
  appClientVersion,
}) => {
  const {bnplOption} = useScaylePaymentMethodState();

  return (
    <>
      {bnplOption && !bnplOption.isDisabled && <RecommendedBadgeSlot />}
      {bnplOption?.isDisabled && (
        <DisabledInvoicePaymentSlot
          BnplInfoLayoutComponent={BnplInfoLayoutComponent}
        />
      )}
      {!bnplOption?.isDisabled && (
        <SelectedInvoicePaymentSlot
          BnplInfoLayoutComponent={BnplInfoLayoutComponent}
        />
      )}
      {!bnplOption?.isDisabled && (
        <BelowFieldsSlot BnplInfoLayoutComponent={BnplInfoLayoutComponent} />
      )}

      {experiments?.length > 0 && (
        <ExperimentActivationTriggerSlot
          experiments={experiments}
          authToken={authToken}
          appClientVersion={appClientVersion}
        />
      )}
    </>
  );
};
